export class StaffHelper {

  static searchOnUserList(userList, searchText) {
    let filteredUserList = []
    if(Array.isArray(userList) && userList.length > 0 && searchText) {
      const search = searchText.toLowerCase()
      filteredUserList = userList.filter((user) => {
        return (
          user.name && user.name.toLowerCase().includes(search) ||
        user.email && user.email.toLowerCase().includes(search)
        )
      })
    }

    return filteredUserList
  }

  static uniqueStaffByUserId(items = []) {
    if (!Array.isArray(items) || items.length === 0) {
      return []
    }
    const seen = new Map()
    for (const user of items) {
      if (!user || !user.userId) {
        continue
      }
      if (!seen.has(user.userId)) {
        seen.set(user.userId, { ...user, id: user.userId })
      }
    }
    return Array.from(seen.values())
  }

  static userIdsWithOrgAccess(staffUsers = [], orgUnitId) {
    const userIds = new Set()
    if (!orgUnitId || !Array.isArray(staffUsers) || staffUsers.length === 0) {
      return userIds
    }
    for (const user of staffUsers) {
      if (user && user.userId && user.orgId === orgUnitId) {
        userIds.add(user.userId)
      }
    }
    return userIds
  }

}
